import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    Flex,
    Divider,
    Text,
    ActionButton,
    DialogTrigger,
    Dialog,
    Heading,
    Content,
    Footer,
} from '@adobe/react-spectrum';
import ShowMenu from '@spectrum-icons/workflow/ShowMenu';
import './HeaderBar.css';
import { setAppRoute } from '../../data/redux/slices/appSlice';
import { getAnalytics, logEvent } from 'firebase/analytics';
import { getId, getInstallations } from 'firebase/installations';
import isMobile from 'ismobilejs';
import RealTimeCustomerProfile from '@spectrum-icons/workflow/RealTimeCustomerProfile';
import { useAuth } from 'react-oidc-context';
import { fetchUserDetails } from '../../data/redux/slices/userDetailsSlice';
import { fetchAuthorDetails } from '../../data/redux/slices/authorDetailsSlice';
import { AvatarImage } from '../avatarImage/AvatarImage';
import { NavLink } from '../common/NavLink';
import { TableFlipIcon } from '../common/TableFlipIcon';
import { DISCORD_INVITE_URL } from '../../config/socialLinks';

export function HeaderBar(props) {
    const dispatch = useDispatch();
    // const auth = window.__auth; //useAuth();
    const auth = useAuth();

    const mobile = isMobile(window.navigator).phone;
    const title = useSelector((state) => state?.app?.title);
    const route = useSelector((state) => state?.app?.route);
    const profileName = useSelector((state) => state?.profile?.metadata?.profileName);
    const avatarUrl = useSelector((state) => state?.profile?.metadata?.avatarUri);

    let headerCaption = '';
    let headerTitle = route.path === '/profile' ? profileName : title;

    switch (route.path) {
        case '':
        case '/':
            headerCaption = 'Let that sweet salt flow!';
            break;
        case '/archetypes':
            headerCaption = 'All of the different ways to annoy your friends!';
            break;
        case '/card':
            headerCaption = '';
            break;
        case '/commanders':
            headerCaption = 'The saltier, the better!';
            break;
        case '/users':
            headerCaption = 'Who is the saltiest of them all?';
            break;
        case '/contact':
            headerCaption = 'File any grievances here';
            break;
        case '/faq':
            headerCaption = 'Eh? Why dis? Who dat?';
            break;
        case '/managedecks':
            headerCaption = 'Manage your decks';
            break;
        case '/changelog':
            headerCaption = 'Information about recent changes';
            break;
        case '/bot':
            headerCaption = 'Bracket checks, right in your server';
            break;
        default:
            headerCaption = '';
    }

    const handleDiscordLink = async () => {
        logEvent(getAnalytics(), 'discord_click');
        window.open(DISCORD_INVITE_URL, `_blank`);
        const installations = getInstallations(window.firebaseApp);
    };

    const handleBlueSkyLink = async () => {
        logEvent(getAnalytics(), 'bluesky_click');
        window.open(`https://bsky.app/profile/commandersalt.bsky.social`, `_blank`);
        const installations = getInstallations(window.firebaseApp);
    };

    const handlePatreonLink = async () => {
        logEvent(getAnalytics(), 'patreon_click');
        window.open(
            `https://patreon.com/user?u=4796225&utm_medium=clipboard_copy&utm_source=copyLink&utm_campaign=creatorshare_creator&utm_content=join_link`,
            `_blank`
        );
        const installations = getInstallations(window.firebaseApp);
    };

    const handleHomeClick = async () => {
        dispatch(setAppRoute({ route: '/' }));
    };

    const handleNewsClick = async () => {
        dispatch(setAppRoute({ route: '/changelog' }));
    };

    const handleHeaderClick = (route) => {
        logEvent(getAnalytics(), `header_open_${route}`);
        dispatch(setAppRoute({ route }));
    };

    const handleMenuClick = (route, closeMethod) => {
        logEvent(getAnalytics(), `header_open_${route}`);
        dispatch(setAppRoute({ route }));
        closeMethod();
    };

    const [screenWidth, setScreenWidth] = React.useState(window.innerWidth);
    React.useEffect(() => {
        const handleResizeWindow = () => setScreenWidth(window.innerWidth);
        // subscribe to window resize event "onComponentDidMount"
        window.addEventListener('resize', handleResizeWindow);
        return () => {
            // unsubscribe "onComponentDestroy"
            window.removeEventListener('resize', handleResizeWindow);
        };
    }, []);

    const handleProfileClick = () => {
        logEvent(getAnalytics(), `header_open_profile`);
        dispatch(fetchUserDetails(profileName));
        dispatch(setAppRoute({ route: `/user/id/${encodeURIComponent(profileName)}` }));
    };

    const headerClassName = screenWidth < 1000 ? 'layered-image-mobile' : 'layered-image';

    return (
        <Flex direction={'row'} justifyContent={'center'}>
            <Flex direction="column" maxWidth={`100vw`} width={2000} alignItems="center">
                <Flex
                    direction="row"
                    width="100%"
                    // margin="5px"
                    justifyContent="space-between"
                    height="54px"
                    UNSAFE_style={{ backgroundColor: '#0e0e0e' }}
                >
                    <Flex direction={'row'}>
                        <NavLink to="/" style={{ display: 'block', textDecoration: 'none' }}>
                            <Flex direction="row" UNSAFE_style={{ marginTop: '10px' }}>
                                <img
                                    src="/resources/chef-kiss-header.png"
                                    width="30px"
                                    height="30px"
                                    alt="CommanderSalt.com - Your new source of inspiration for degenerate MtG Commander/EDH decks!"
                                    style={{ paddingLeft: '10px', paddingRight: '10px' }}
                                />
                                <Text UNSAFE_className="HeaderText">COMMANDERSALT.COM</Text>
                            </Flex>
                        </NavLink>
                        {screenWidth > 1000 && (
                            <Flex direction={'row'} marginTop={10} marginStart={50} columnGap={30} alignSelf={'start'}>
                                <Divider orientation={'vertical'} size={'S'} height={30} />
                                <NavLink
                                    to="/meta"
                                    className="navLinksHeader"
                                    onClick={() => logEvent(getAnalytics(), 'header_open_/meta')}
                                >
                                    cEDH META
                                </NavLink>
                                <NavLink
                                    to="/commanders"
                                    className="navLinksHeader"
                                    onClick={() => logEvent(getAnalytics(), 'header_open_/commanders')}
                                >
                                    COMMANDERS
                                </NavLink>
                                <NavLink
                                    to="/users"
                                    className="navLinksHeader"
                                    onClick={() => logEvent(getAnalytics(), 'header_open_/users')}
                                >
                                    USERS
                                </NavLink>
                                <NavLink
                                    to="/archetypes"
                                    className="navLinksHeader"
                                    onClick={() => logEvent(getAnalytics(), 'header_open_/archetypes')}
                                >
                                    ARCHETYPES
                                </NavLink>
                                <Divider orientation={'vertical'} size={'S'} height={30} />
                                <NavLink
                                    to="/changelog"
                                    className="navLinksHeader"
                                    onClick={() => logEvent(getAnalytics(), 'header_open_/changelog')}
                                >
                                    CHANGELOG
                                </NavLink>
                                <NavLink
                                    to="/faq"
                                    className="navLinksHeader"
                                    onClick={() => logEvent(getAnalytics(), 'header_open_/faq')}
                                >
                                    FAQ
                                </NavLink>
                                <NavLink
                                    to="/bot"
                                    className="navLinksHeader navLinksHeader--withIcon"
                                    onClick={() => logEvent(getAnalytics(), 'header_open_/bot')}
                                >
                                    <img
                                        src="/resources/discord-mark.png"
                                        alt=""
                                        aria-hidden="true"
                                        className="navLinksHeaderIcon"
                                    />
                                    BOT
                                </NavLink>
                            </Flex>
                        )}
                    </Flex>
                    <Flex direction={'row'}>
                        {screenWidth > 1000 && (
                            <Flex direction={'row'} marginTop={10} columnGap={10} marginRight={25}>
                                <ActionButton
                                    onPress={handlePatreonLink}
                                    aria-label="Support us on Patreon!"
                                    isQuiet={true}
                                    data-role="icon-circle-sm"
                                >
                                    <img src="/resources/patreon.png" alt="Patreon" />
                                </ActionButton>
                                <ActionButton
                                    onPress={handleBlueSkyLink}
                                    aria-label="Follow us on BlueSky!"
                                    isQuiet={true}
                                    data-role="icon-circle-sm"
                                >
                                    <img src="/resources/bluesky.png" alt="BlueSky" />
                                </ActionButton>
                                <ActionButton
                                    onPress={handleDiscordLink}
                                    aria-label="Join our Discord!"
                                    isQuiet={true}
                                    data-role="icon-circle-sm"
                                >
                                    <img src="/resources/discord.png" alt="Discord" />
                                </ActionButton>
                            </Flex>
                        )}
                        <span style={{ marginRight: '5px', alignSelf: 'center', paddingRight: 5 }}>
                            <span style={{ marginLeft: '5px', alignSelf: 'right' }}>
                                <DialogTrigger type="popover" mobileType="tray">
                                    <ActionButton isQuiet={true} data-role="icon-circle-sm">
                                        <AvatarImage size={25} avatarUrl={avatarUrl} showDefaultIcon={true} />
                                    </ActionButton>
                                    {(close) => (
                                        <Dialog UNSAFE_className="appMenuDialog">
                                            {/* Spectrum tray sizing: omit minHeight on
                                                <Content> so Spectrum's own overflow
                                                handler kicks in. The prior minHeight:
                                                100vh forced content taller than the
                                                tray viewport without enabling scroll,
                                                cutting off everything past the fold. */}
                                            <Heading UNSAFE_className="appMenuBrand">commandersalt</Heading>
                                            <Content>
                                                <nav className="appMenu" aria-label="Main menu">
                                                    {!auth?.isAuthenticated && !auth.isLoading && (
                                                        <AppMenuSection label="Account">
                                                            <AppMenuLink
                                                                as="button"
                                                                onClick={() => {
                                                                    close();
                                                                    void auth.signinRedirect();
                                                                }}
                                                            >
                                                                Log in / Sign up
                                                            </AppMenuLink>
                                                            <AppMenuLink to="/verify-email" onNavigate={close}>
                                                                Verify email
                                                            </AppMenuLink>
                                                        </AppMenuSection>
                                                    )}
                                                    {auth.isAuthenticated && (
                                                        <AppMenuSection label={profileName || 'Account'}>
                                                            <AppMenuLink
                                                                to={`/user/id/${encodeURIComponent(profileName)}`}
                                                                onNavigate={() => {
                                                                    close();
                                                                    logEvent(getAnalytics(), 'header_open_profile');
                                                                    dispatch(fetchUserDetails(profileName));
                                                                }}
                                                            >
                                                                Profile
                                                            </AppMenuLink>
                                                            <AppMenuLink
                                                                to="/linkedaccounts"
                                                                onNavigate={() => {
                                                                    close();
                                                                    logEvent(
                                                                        getAnalytics(),
                                                                        'header_open_/linkedaccounts'
                                                                    );
                                                                }}
                                                            >
                                                                Linked accounts
                                                            </AppMenuLink>
                                                            <AppMenuLink
                                                                to="/managedecks"
                                                                onNavigate={() => {
                                                                    close();
                                                                    logEvent(
                                                                        getAnalytics(),
                                                                        'header_open_/managedecks'
                                                                    );
                                                                }}
                                                            >
                                                                Manage decks
                                                            </AppMenuLink>
                                                            <AppMenuLink
                                                                to="/settings"
                                                                onNavigate={() => {
                                                                    close();
                                                                    logEvent(getAnalytics(), 'header_open_/settings');
                                                                }}
                                                            >
                                                                Settings
                                                            </AppMenuLink>
                                                            <AppMenuLink
                                                                as="button"
                                                                onClick={() => {
                                                                    close();
                                                                    void auth.signoutSilent();
                                                                    window.signOutRedirect();
                                                                }}
                                                            >
                                                                Log out
                                                            </AppMenuLink>
                                                        </AppMenuSection>
                                                    )}
                                                    {screenWidth < 1000 && (
                                                        <AppMenuSection label="Browse">
                                                            <AppMenuLink
                                                                to="/"
                                                                onNavigate={() => {
                                                                    close();
                                                                    logEvent(getAnalytics(), 'header_open_/');
                                                                }}
                                                            >
                                                                Leaderboard
                                                            </AppMenuLink>
                                                            <AppMenuLink
                                                                to="/commanders"
                                                                onNavigate={() => {
                                                                    close();
                                                                    logEvent(getAnalytics(), 'header_open_/commanders');
                                                                }}
                                                            >
                                                                Commanders
                                                            </AppMenuLink>
                                                            <AppMenuLink
                                                                to="/users"
                                                                onNavigate={() => {
                                                                    close();
                                                                    logEvent(getAnalytics(), 'header_open_/users');
                                                                }}
                                                            >
                                                                Users
                                                            </AppMenuLink>
                                                            <AppMenuLink
                                                                to="/archetypes"
                                                                onNavigate={() => {
                                                                    close();
                                                                    logEvent(getAnalytics(), 'header_open_/archetypes');
                                                                }}
                                                            >
                                                                Archetypes
                                                            </AppMenuLink>
                                                            <AppMenuLink
                                                                to="/meta"
                                                                onNavigate={() => {
                                                                    close();
                                                                    logEvent(getAnalytics(), 'header_open_/meta');
                                                                }}
                                                            >
                                                                cEDH meta
                                                            </AppMenuLink>
                                                        </AppMenuSection>
                                                    )}
                                                    <AppMenuSection label="Reference">
                                                        <AppMenuLink
                                                            to="/powerlevels"
                                                            onNavigate={() => {
                                                                close();
                                                                logEvent(getAnalytics(), 'header_open_/powerlevels');
                                                            }}
                                                        >
                                                            Power levels
                                                        </AppMenuLink>
                                                        <AppMenuLink
                                                            to="/algorithm"
                                                            onNavigate={() => {
                                                                close();
                                                                logEvent(getAnalytics(), 'header_open_/algorithm');
                                                            }}
                                                        >
                                                            The algorithm
                                                        </AppMenuLink>
                                                        {screenWidth < 1000 && (
                                                            <>
                                                                <AppMenuLink
                                                                    to="/bot"
                                                                    onNavigate={() => {
                                                                        close();
                                                                        logEvent(getAnalytics(), 'header_open_/bot');
                                                                    }}
                                                                >
                                                                    Discord bot
                                                                </AppMenuLink>
                                                                <AppMenuLink
                                                                    to="/changelog"
                                                                    onNavigate={() => {
                                                                        close();
                                                                        logEvent(
                                                                            getAnalytics(),
                                                                            'header_open_/changelog'
                                                                        );
                                                                    }}
                                                                >
                                                                    Changelog
                                                                </AppMenuLink>
                                                                <AppMenuLink
                                                                    to="/faq"
                                                                    onNavigate={() => {
                                                                        close();
                                                                        logEvent(getAnalytics(), 'header_open_/faq');
                                                                    }}
                                                                >
                                                                    FAQ
                                                                </AppMenuLink>
                                                            </>
                                                        )}
                                                    </AppMenuSection>
                                                </nav>
                                            </Content>
                                            {screenWidth < 1000 && (
                                                <Footer UNSAFE_className="appMenuFooter">
                                                    <ActionButton
                                                        onPress={handlePatreonLink}
                                                        aria-label="Support us on Patreon!"
                                                        isQuiet
                                                        data-role="icon-circle-sm"
                                                    >
                                                        <img src="/resources/patreon.png" alt="" />
                                                    </ActionButton>
                                                    <ActionButton
                                                        onPress={handleBlueSkyLink}
                                                        aria-label="Follow us on BlueSky!"
                                                        isQuiet
                                                        data-role="icon-circle-sm"
                                                    >
                                                        <img src="/resources/bluesky.png" alt="" />
                                                    </ActionButton>
                                                    <ActionButton
                                                        onPress={handleDiscordLink}
                                                        aria-label="Join our Discord!"
                                                        isQuiet
                                                        data-role="icon-circle-sm"
                                                    >
                                                        <img src="/resources/discord.png" alt="" />
                                                    </ActionButton>
                                                </Footer>
                                            )}
                                        </Dialog>
                                    )}
                                </DialogTrigger>
                            </span>
                        </span>
                    </Flex>
                </Flex>
                <div className={`${headerClassName} headerBannerWrap`}>
                    <div className="leaderboard-title" data-eyebrow={headerCaption}>
                        {headerTitle}
                    </div>
                    <TableFlipIcon width={screenWidth < 1000 ? 140 : 260} color="#ffffff" className="headerTableFlip" />
                </div>
            </Flex>
        </Flex>
    );
}

function AppMenuSection({ label, children }) {
    return (
        <div className="appMenuSection">
            <div className="appMenuSectionLabel">{label}</div>
            <div className="appMenuSectionItems">{children}</div>
        </div>
    );
}

/**
 * Single nav row. Renders either as a router-aware NavLink (default) or
 * as a plain <button> when `as="button"` (used for auth flows that
 * trigger redirects rather than navigate). The seared/steel styling is
 * driven entirely by .appMenuLink in HeaderBar.css.
 */
function AppMenuLink({ to, onNavigate, onClick, as, children }) {
    if (as === 'button') {
        return (
            <button type="button" className="appMenuLink" onClick={onClick}>
                <span className="appMenuLinkLabel">{children}</span>
            </button>
        );
    }
    return (
        <NavLink to={to} className="appMenuLink" onClick={onNavigate}>
            <span className="appMenuLinkLabel">{children}</span>
        </NavLink>
    );
}
